import React from 'react';
import SAInputDistanceLabel from "../../common/input/SAInputDistanceLabel";
import SAInputPercentageLabel from "../../common/input/SAInputPercentageLabel";
import CarDamageModification from "../management/carmodification/CarDamageModification";
import {injectIntl} from "react-intl";
import IdentityDocuments from "./IdentityDocuments";
import SAInputComponent from "../../common/input/SAInputComponent";
import IdentityData from "../../interventiondetail/mobility/IdentityData";

class DeliveryModalTab extends React.Component {

  handleBeforeUpload = (file, category) => {
    const {deliveryReport, deliveryReport: {fileList}} = this.props;
    fileList[category] = [...fileList[category], file];
    deliveryReport.fileList = fileList;
    deliveryReport[category] = [...fileList, file];
    this.updateData(deliveryReport);
    return false;
  };

  handleFileRemove = (file, category) => {
    const {deliveryReport} = this.props;
    if (file.originFileObj) {
      const fileList = deliveryReport.fileList;
      fileList[category] = fileList[category].filter(f => f.uid !== file.uid);
      this.updateData(deliveryReport);
      return;
    }
    deliveryReport.outdatedFiles = [...deliveryReport.outdatedFiles, file.uid];
    this.updateData(deliveryReport);
  };

  handleAttachmentsChange = ({fileList}) => {
    const {deliveryReport} = this.props;
    deliveryReport.attachments = fileList;
    this.updateData(deliveryReport);
  };

  onInputNumberChange = (value, name) => {
    const {deliveryReport} = this.props;
    deliveryReport[name] = value;
    this.updateData(deliveryReport);
  };

  onInputTextChange = (e) => {
    const {deliveryReport} = this.props;
    const {target: {name, value}} = e;
    deliveryReport[name] = value;
    this.updateData(deliveryReport);
  };

  updateData = (data) => {
    const {name, onReportUpdate} = this.props;
    onReportUpdate(name, data);
  };

  render() {
    const {intl: {formatMessage}, deliveryReport: {fuel, mileage, advisorComment, attachments = []}, errors = {}, identityDocuments = {}, identityData, onIdentityDocumentsUpdate} = this.props;

    const nbIdentityDocuments = identityDocuments.attachments ? identityDocuments.attachments.length : 0;

    return (
      <div>
        <div className="row">
          <ul className="list col-md-6 col-xxl-6">
            <li>
              <SAInputComponent label={formatMessage({id: 'appointment.detail.mobility.mobility-solution.attachments.title'}, {count: nbIdentityDocuments, max: 4})}>
                <IdentityDocuments identityDocuments={identityDocuments} onChange={onIdentityDocumentsUpdate}/>
                <IdentityData identity={identityData}/>
              </SAInputComponent>
            </li>
          </ul>
          <ul className="list col-md-6 col-xxl-6">
            <li>
              <SAInputPercentageLabel label={formatMessage({id: 'vehicle.current-fuel'})} value={fuel} error={errors.fuel}
                                      onChange={(n) => this.onInputNumberChange(n, "fuel")}/>
            </li>
            <li>
              <SAInputDistanceLabel label={formatMessage({id: 'vehicle.current-mileage'})} value={mileage} error={errors.mileage}
                                    onChange={(n) => this.onInputNumberChange(n, "mileage")}/>
            </li>
          </ul>
        </div>

        <div className="row">
          <ul className="list col-md-12 col-xxl-12">
            <li>
              <CarDamageModification vehicle={{advisorComment}} attachments={attachments} onInputTextChange={this.onInputTextChange}
                                     handleBeforeUpload={this.handleBeforeUpload} handleAttachmentsChange={this.handleAttachmentsChange}
                                     handleFileRemove={this.handleFileRemove} error={errors}/>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default injectIntl(DeliveryModalTab);



// WEBPACK FOOTER //
// ./src/components/carpark/delivery/DeliveryModalTab.js